export default __webpack_public_path__ + "static/media/mob_sf.b3654a18.png";